import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import PromptsListPage from 'features/prompts/pages/PromptsListPage';
import PromptEditorPage from 'features/prompts/pages/PromptEditorPage';
import PromptVersionUsagePage from 'features/prompts/pages/PromptVersionUsagePage';

/**
 * PromptsPage — sub-router for `/:team/prompts/*`.
 *   /:team/prompts       → registry list
 *   /:team/prompts/new   → editor on an unsaved draft (created on first save)
 *   /:team/prompts/:id   → prompt editor
 *
 * Datasets are a standalone, top-level feature (`/:team/datasets`) — they are no
 * longer owned by or nested under prompts.
 */
export default function PromptsPage() {
  const { team } = useParams();
  const { pathname } = useLocation();
  const base = `/${encodeURIComponent(team)}/prompts`;
  const after = pathname.startsWith(base)
    ? pathname.slice(base.length).replace(/^\/+/, '').replace(/\/+$/, '')
    : '';
  const parts = after ? after.split('/') : [];

  if (parts.length === 0) return <PromptsListPage />;
  // `new` is a draft, not an id — nothing exists server-side until it's saved.
  if (parts[0] === 'new') return <PromptEditorPage promptId={null} />;
  // /:id/usage/:versionHash — one version's analytics, on its own page so the
  // request is scoped to that version rather than loading every version's data.
  if (parts[1] === 'usage' && parts[2]) {
    return <PromptVersionUsagePage promptId={parts[0]} versionHash={parts[2]} />;
  }
  return <PromptEditorPage promptId={parts[0]} />;
}
